import useGetTransferPositions from "../../hooks/useGetTransferPositions";

const useGetFundsFiltered = () => {
	const { positions } = useGetTransferPositions();
	return {
		fundsAvailable: positions.filter((i) => i.transferTaxExempt || i.transferTaxExempt === null),
		fundInvalidOwners: positions.filter((i) => i.invalidOwner),
		fundNotAvailable: positions.filter((i) => !i.transferTaxExempt && i.transferTaxExempt !== null)
	};
};

export default useGetFundsFiltered;
